import React from 'react'
import { Card } from 'react-bootstrap'
import { Link } from 'react-router-dom'

const BookTrip = () => {
  return (
    <div>
      <p>To book a trip:  </p>
      <ol>
        <li>Go to the homepage</li>
        <li> On the nav bar, click on bookings, it will lead to the bookings page and you can make your choice</li>
      </ol>
      <h5 className='text-center'><b>OR</b></h5>
      <ol>
        <li>on the hero section, input your details and click on the let’s go button</li>
      </ol>
      <br/>
      <p>If you are unable to do any of those, you can book a trip using this link <Link to='/booking'>www.tripz/bookings.com</Link></p>
      
    </div>
  )
}

export default BookTrip
